import { deepCopy } from '@portals/shared/common/utils';
import { ApiDto } from '@portals/shared/portal/ApiDto';
import { TrackRoute } from '@portals/shared-frontend/components';
import { useMemo } from 'react';
import useSWR from 'swr';

import ApiPage from '../../components/ApiPage';
import { API_EXPLORER_TABS, EXTERNAL_CLASSIFICATIONS } from '../../content';

export default function CommercialApis() {
  const { data: apis, mutate } = useSWR<ApiDto[]>('/api?type=REST');
  const commercialApis = useMemo(() => {
    return apis
      ?.filter((api) => EXTERNAL_CLASSIFICATIONS.has(api.classification))
      .filter(({ tags }) => !tags.includes('PSD2'));
  }, [apis]);

  return (
    <ApiPage
      apiType={API_EXPLORER_TABS.Commercial}
      apis={commercialApis}
      onApiFavouriteChange={(apiId, isFavorite) =>
        mutate((apis) => {
          if (apis) {
            const updatedApis = deepCopy(apis);
            const index = updatedApis.findIndex((api) => api.id === apiId);
            updatedApis[index]!.isFavorite = isFavorite;
            return updatedApis;
          }
          return;
        }, false)
      }
      title="Commercial APIs"
    >
      <TrackRoute name="Commercial APIs" path="/explorer/apis/commercial" type="commercial" />
    </ApiPage>
  );
}
